import React from "react";
import "../styles/Projects.css";
import FolderOpenRoundedIcon from "@material-ui/icons/FolderOpenRounded";
import FadeInSection from "./FadeInSection";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import Carousel from "react-bootstrap/Carousel";
import ExternalLinks from "./ExternalLinks";

class Projects extends React.Component {
  constructor() {
    super();
    this.state = {
      expanded: true,
      activeKey: "1"
    };
    this.handleSelect = this.handleSelect.bind(this);
  }
  handleSelect(eventKey) {
    this.setState({
      activeKey: eventKey
    });
  }
  render() {
    const spotlightProjects = {
      "ISSA": {
        title: "ISSA",
        desc:
          "A chatbot that assists users in navigating the Spanish Social Security system by helping them find services, complete procedures, and resolve general inquiries",
        techStack: "PYTHON, MACHINE LEARNING",
        open: "https://sede.seg-social.gob.es/wps/portal/sede/sede/Inicio",
        image: "/assets/issa.png"
      },"Sarbide": {
        title: "Sarbide",
        desc:
          "The Computer System for Galdakao Hospital represents a pioneering initiative that originated amidst the challenging backdrop of the COVID-19 pandemic. This sophisticated system is designed to offer an array of comprehensive solutions, enabling the seamless management of various aspects critical to hospital functionality.",
        techStack: ".NET Full Stack",
        link: "",
        open: "https://www.redytel.es/el-proyecto-sarbide-gana-el-premio-a-las-mejores-practicas-innovadoras-en-los-hospitales-de-osakidetza/",
        image: "/assets/Sarbide.png"
      },
      "SmartContract Vault": {
        title: "SmartContract Vault",
        desc:
          "A decentralized application (DApp) that allows users to register, verify, and validate the authenticity of smart contracts on the Ethereum blockchain",
        techStack: "SOLIDITY, TYPESCRIPT",
        link: "https://github.com/anderalvarez/SmartContract-Vault",
        open: "",
        image: "/assets/SmartContractVault.png"
      }// ,
      // "Tall Tales": {
      //   title: "tall tales",
      //   desc:
      //     "A multi-player story-telling web game for 3-5 players. Its usage of sockets to allow for concurrent gameplay, connecting friends across the internet.",
      //   techStack: "NODE.JS (SOCKET.IO), REACT.JS, MONGODB",
      //   link: "https://github.com/gazijarin/TallTales",
      //   open: "https://talltales.herokuapp.com/",
      //   image: "/assets/talltales.png"
      // },
      // Portfolio: {
      //   title: "portfolio.js",
      //   desc:
      //     "A small JS library that helps with clear and succinct data presentation.",
      //   techStack: "NODE.JS (EXPRESS.JS)",
      //   link: "https://github.com/gazijarin/Portfolio.js",
      //   open: "https://afternoon-ocean-92382.herokuapp.com/",
      //   image: "/assets/portfolio.png"
      // }
    };
    const projects = {
      "SmartContract Vault": {
        desc:
          "A decentralized application (DApp) that allows users to register, verify, and validate the authenticity of smart contracts on the Ethereum blockchain.",
        techStack: "Solidity, TypeScript, Ethereum Virtual Machine",
        link: "https://github.com/anderalvarez/SmartContract-Vault",
        open: ""
      }//,
      // "Adam A.I.": {
      //   desc:
      //     "A self-learning A.I. that learns to traverse through a complex maze using the genetic algorithm.",
      //   techStack: "Javascript, HTML / CSS",
      //   link: "https://github.com/gazijarin/adamai",
      //   open: "https://gazijarin.github.io/AdamAI/"
      // },
      // "Distributed Logging and Monitoring System": {
      //   desc:
      //     "A system that establishes an ORM connection to a Prisma client in order to communicate logs from microservices.",
      //   techStack: "Node.js (Express.js), React.js, PostgreSQL",
      //   link:
      //     "https://github.com/gazijarin/Distributed-Logging-and-Monitoring-System"
      // },
      // "Odin Bot": {
      //   desc:
      //     "A Telegram bot that helps you excel on your daily tasks through Node NLP.",
      //   techStack: "Javascript, Node.js, Natural NLP, Telegram API",
      //   link: "https://github.com/gazijarin/OdinBot",
      //   open: ""
      // },
      // "Game Centre": {
      //   desc:
      //     "An Android app consisting of three board games, including multiplayer, autosave, user authentication, etc.",
      //   techStack: "Java, Android Studio",
      //   link: "https://github.com/gazijarin/gamecentre",
      //   open: ""
      // },
      // "Minimax Stonehenge": {
      //   desc:
      //     "Two-player, zero-sum game with a strategic Minimax artificial intelligence.",
      //   techStack: "Python",
      //   link: "https://github.com/gazijarin/stonehenge",
      //   open: ""
      // }
    };

    return (
      <div id="projects">
        <div className="section-header ">
          <span className="section-title">/ Projects</span>
        </div>
        <Carousel>
          {Object.keys(spotlightProjects).map((key, i) => (
            <Carousel.Item key={i}>
              <img
                className="d-block w-100"
                src={spotlightProjects[key]["image"]}
                alt={key}
              />
              <div className="caption-bg">
                <Carousel.Caption>
                  <h3>{spotlightProjects[key]["title"]}</h3>
                  <p>{spotlightProjects[key]["desc"]}</p>
                  <div className="techStack">{spotlightProjects[key]["techStack"]}</div>
                  <ExternalLinks
                    githubLink={spotlightProjects[key]["link"]}
                    openLink={spotlightProjects[key]["open"]}
                  ></ExternalLinks>
                </Carousel.Caption>
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
        <div className="project-container">
          <ul className="projects-grid">
            {Object.keys(projects).map((key, i) => (
              <FadeInSection key={i} delay={`${i + 1}00ms`}>
                <li className="projects-card">
                  <div className="card-header">
                    <div className="folder-icon">
                      <FolderOpenRoundedIcon style={{ fontSize: 35 }} />
                    </div>
                    <ExternalLinks
                      githubLink={projects[key]["link"]}
                      openLink={projects[key]["open"]}
                    ></ExternalLinks>
                  </div>
                  <div className="card-title">{key}</div>
                  <div className="card-desc">{projects[key]["desc"]}</div>
                  <div className="card-tech">{projects[key]["techStack"]}</div>
                </li>
              </FadeInSection>
            ))}
          </ul>
        </div>
      </div>
    );
  }
}

export default Projects;
